import { useEffect, useRef } from 'react';
import { useInView } from 'motion/react';
import { Link } from 'react-router-dom';
import Button from '@/components/Button.tsx';
import VIDEO_SOURCE from '@/assets/satprac-tour-video.mp4';
import DEFAULT_POSTER from '@/assets/video-thumbnail.png';
import NativePlayer from '@/components/VideoPlayer/NativePlayer.tsx';

const Testimonials = () => (
  <section className="bg-[#422933] pt-28 pb-14 md:pb-28 px-4 text-center">
    <h3 className="font-primary text-title md:text-heroTitle !font-extraBold text-[#FEE7E1]">
      SATPrac site tour
    </h3>
    <strong className="block font-primary font-semibold text-body md:text-[1.125rem] text-[#D3B6AD] mt-4">
      Take a tour of the site to see how it will help you win the digital SAT game!
    </strong>

    <SiteTourVideo />

    <p
      className="block font-bold text-[#FEE7E1] text-body md:text-[2.5rem]
      md:leading-[110%] md:-tracking-[0.8px] mb-6 md:mb-12"
    >
      If you are ready to do what it takes <br />
      to win the <span className="text-primary font-extraBold">digital SAT</span>, create an<br />
      account and let’s do this together!
    </p>

    <Link to="/sign-up" className="m:inline-flex">
      <Button className="px-6 rounded-full m:h-11" type="button">GET STARTED NOW</Button>
    </Link>

    <p className="block font-bold text-[#FEE7E1] text-body md:text-heroSubtitle leading-normal mt-12">
      After creating an account,<br />
      you’ll be able to select the plan that works for you <br /> and unlock game day secrets!
    </p>
  </section>
);

const SiteTourVideo = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const isInView = useInView(videoRef);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    if (isInView) videoElement.play();
    else videoElement.pause();
  }, [isInView]);

  return (
    <NativePlayer
      ref={videoRef}
      src={VIDEO_SOURCE}
      poster={DEFAULT_POSTER}
      className="w-full max-w-3xl sm:px-6 mx-auto mt-12 mb-12 md:mb-36"
    />
  );
};

export default Testimonials;
